/** Parentescos para etiquetar a cada persona dentro de una familia de la iglesia (mismas claves que la API). */
export const FAMILY_ROLES = {
  jefe: 'Cabeza de familia',
  papa: 'Papá',
  mama: 'Mamá',
  esposo: 'Esposo',
  esposa: 'Esposa',
  hijo: 'Hijo',
  hija: 'Hija',
  hermano: 'Hermano',
  hermana: 'Hermana',
  abuelo: 'Abuelo',
  abuela: 'Abuela',
  nieto: 'Nieto',
  nieta: 'Nieta',
  tio: 'Tío',
  tia: 'Tía',
  primo: 'Primo',
  prima: 'Prima',
  sobrino: 'Sobrino',
  sobrina: 'Sobrina',
  suegro: 'Suegro',
  suegra: 'Suegra',
  yerno: 'Yerno',
  nuera: 'Nuera',
  cunado: 'Cuñado',
  cunada: 'Cuñada',
  tutor: 'Tutor',
  padrino: 'Padrino',
  madrina: 'Madrina',
  ahijado: 'Ahijado',
  ahijada: 'Ahijada',
  otro: 'Otro',
} as const;

export type FamilyRole = keyof typeof FAMILY_ROLES;
export const FAMILY_ROLE_KEYS = Object.keys(FAMILY_ROLES) as [FamilyRole, ...FamilyRole[]];

export const familyRoleLabel = (key: string) => (FAMILY_ROLES as Record<string, string>)[key] ?? key;
